import(/* webpackMode: "eager", webpackExports: ["SignInForm"] */ "/codebuild/output/src1766684577/src/frontend-v2/app/(auth)/_components/forms/SignInForm.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1766684577/src/frontend-v2/node_modules/next/dist/client/app-dir/link.js");
